import { Checkbox } from '@atlaskit/checkbox';
import { CheckboxField } from '@atlaskit/form';
import { Flex, xcss } from '@atlaskit/primitives';
import { MultiStepDragAndDrop } from '@atlassian/mpac-partners';
import { TextInput } from '@atlassian/mpac-ui';
import { WindowUtils } from '@atlassian/mpac-utils';

import FeaturedTileConfig from './FeaturedTileConfig';

import type { FeaturedSectionConfigurationType } from '@atlassian/mpac-types';

const flexStyles = xcss({ gap: 'space.200', flexDirection: 'column' });
const containerStyles = xcss({
  marginTop: 'space.400',
  gap: 'space.300',
  flexDirection: 'column',
});

type Props = {
  defaultValue?: Partial<FeaturedSectionConfigurationType>;
  name: string;
};

const FeaturedSectionContainer = ({
  defaultValue = { heading: '', subHeading: '', tiles: [], isShuffleEnabled: false },
  name,
}: Props) => {
  const tiles = (defaultValue.tiles || []).map((item, index) => ({
    ...item,
    id: WindowUtils.randomUUID(),
    isAccordianBoxOpen: index === 0,
  }));

  return (
    <Flex xcss={containerStyles} testId="featured-section-container">
      <h3>Featured Section Configuration</h3>
      <Flex xcss={flexStyles}>
        <TextInput
          label="Heading"
          name={`${name}.heading`}
          defaultValue={defaultValue.heading}
          placeholder="Enter section heading"
          isRequired
          applyDefaultValidation
        />
        <TextInput
          label="Sub Heading"
          name={`${name}.subHeading`}
          defaultValue={defaultValue.subHeading}
          placeholder="Enter section sub heading"
          isRequired
          applyDefaultValidation
        />
        <CheckboxField
          name={`${name}.isShuffleEnabled`}
          defaultIsChecked={defaultValue.isShuffleEnabled}
        >
          {({ fieldProps }) => <Checkbox {...fieldProps} label="Is Shuffle Enabled?" />}
        </CheckboxField>
        <h4>Tiles</h4>
        <MultiStepDragAndDrop
          label="Tile"
          name={`${name}.tiles`}
          value={tiles}
          content={FeaturedTileConfig}
          addNewRecordLabel="Add New Tile"
        />
      </Flex>
    </Flex>
  );
};

export default FeaturedSectionContainer;
